import React from 'react';

const TermsConditions = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.9142 13.2857C20.9155 12.642 20.7557 12.0082 20.4493 11.4421C20.1429 10.8759 19.6997 10.3955 19.1601 10.0445C18.6204 9.69356 18.0015 9.48323 17.3598 9.4327C16.7181 9.38218 16.0739 9.49308 15.486 9.75529C14.8981 10.0175 14.3852 10.4227 13.9939 10.9339C13.6027 11.4451 13.3457 12.0461 13.2463 12.6821C13.1468 13.3181 13.2081 13.9689 13.4246 14.5751C13.6411 15.1813 14.0059 15.7237 14.4857 16.1529V21L17.0571 19.7833L19.6285 21V16.1529C20.0327 15.7925 20.3561 15.3508 20.5777 14.8567C20.7992 14.3626 20.9139 13.8272 20.9142 13.2857ZM18.3428 18.9686L17.0571 18.36L15.7714 18.9686V16.9179C16.6022 17.218 17.5119 17.218 18.3428 16.9179V18.9686ZM17.0571 15.8572C16.5485 15.8572 16.0513 15.7064 15.6285 15.4238C15.2056 15.1412 14.876 14.7396 14.6814 14.2698C14.4868 13.7999 14.4358 13.2829 14.5351 12.7841C14.6343 12.2853 14.8792 11.8271 15.2388 11.4675C15.5984 11.1078 16.0566 10.8629 16.5554 10.7637C17.0542 10.6645 17.5713 10.7154 18.0411 10.9101C18.511 11.1047 18.9126 11.4343 19.1951 11.8571C19.4777 12.28 19.6285 12.7772 19.6285 13.2857C19.6277 13.9675 19.3566 14.6211 18.8745 15.1032C18.3924 15.5852 17.7388 15.8564 17.0571 15.8572V15.8572Z'
        fill='black'
      />
      <path d='M11.9143 10.7143H7.41431V12H11.9143V10.7143Z' fill='black' />
      <path
        d='M13.8429 6.85715H7.41431V8.14286H13.8429V6.85715Z'
        fill='black'
      />
      <path
        d='M5.48566 21C5.14478 20.9996 4.81796 20.864 4.57692 20.623C4.33588 20.382 4.20031 20.0551 4.19995 19.7143V4.28571C4.20031 3.94483 4.33588 3.61801 4.57692 3.37697C4.81796 3.13593 5.14478 3.00036 5.48566 3H15.7714C16.1122 3.00036 16.4391 3.13593 16.6801 3.37697C16.9211 3.61801 17.0567 3.94483 17.0571 4.28571V6.85714H15.7714V4.28571H5.48566V19.7143H11.9142V21H5.48566Z'
        fill='black'
      />
    </svg>
  );
};

export default TermsConditions;
